// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"Layout_mainContent__o_ubu","noBanner":"Layout_noBanner__4YDy7"};